export const AvatarTestIdFactory = {
    getAvatarBase: () => 'avatar',
    getAvatarListBase: () => [AvatarTestIdFactory.getAvatarBase(), 'list'].join('-'),
    getAvatarTestId: (testId) => [AvatarTestIdFactory.getAvatarBase(), testId].join('-'),
    getAvatarListTestId: (testId) => [AvatarTestIdFactory.getAvatarListBase(), testId].join('-'),
    internalGenerateAvatarInListTestId: (testId, index) => [testId, index].join('-'),
};
